/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import './App.css';
import { ErrorProvider } from './components/ErrorContext/ErrorContext';
import Router from './Router';
import { initializeLanguageBundles } from './utils/langUtils';
import '@ui5/webcomponents-fiori/dist/illustrations/AllIllustrations.js';
import '@ui5/webcomponents-icons/dist/AllIcons';

async function start() {
    await initializeLanguageBundles();
}
start();

const App: React.FC = () => {
    return (
        <>
            <ErrorProvider>
                <Router />
            </ErrorProvider>
        </>
    );
};

export default App;
